<script>
import { FancyboxGallery } from "@/shared/components/fancybox/fancybox";
export default FancyboxGallery;
</script>

<template>
    <slot name="default" ref="container"></slot>
</template>

<style lang="scss">
@import "@fancyapps/ui/dist/fancybox/fancybox.css";
</style>
